import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import Cookies from "universal-cookie";
import { decode } from "base-64";
const cookies = new Cookies();
var token = cookies.get("wmtoken");



export const getSinglePostData = async (key) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("title", key.queryKey[1]);
        fd.append('view', 'EDIT')
        var res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/getPostData`, data: fd })
        return await res.data
    }
};


export const uploadImageForEditor = async (file) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("image", file);
        var res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/uploadInternalPhoto`, data: fd })
        return await res.data
    }
}